import React from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes';
import { Link } from 'react-router-dom';

interface BannerProps {
    apiValues: any;
}



const Benefits: React.FC<BannerProps> = ({ apiValues }) => {

    const route = all_routes;



    const benefits = [
        {
            iconClass: "isax isax-book-1 fs-24",
            bgClass: "bg-primary-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Trusted by 113K students",
            desc: "Last year alone, Palanivel Overseas fulfilled dreams of over 113K students to study abroad. Your success is our mission!"
        },
        {
            iconClass: "isax isax-bookmark5 fs-24",
            bgClass: "bg-secondary-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Lifetime Access",
            desc: "When you enroll in our courses, you’re not just signing up for a temporary learning experience—you’re making a long-term investment."
        },
        {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        },
        {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        },
        // Add more benefit objects as needed...
    ];

    return (
        <>
            {/* benefits */}
            <section className="benefit-section">
                <div className="container">
                    <div className="section-header text-start p-3">
                        <span className="text-red-600">
                            {apiValues?.IndividualUniversityDetails?.plans?.title}
                        </span>
                        <h2 className=' text-[#1D1753] mb-2'>
                            {apiValues?.IndividualUniversityDetails?.plans?.description}
                        </h2>
                        <p>
                            {apiValues?.IndividualUniversityDetails?.plans?.miniDescription}
                        </p>
                    </div>
                    <div className="row"
                        data-aos-duration="3000">
                        {/* {
                            benefits.map((item, index) => {
                                return (

                                     { */}

                        {

                            (Array.isArray(apiValues?.IndividualUniversityDetails?.plans?.planCards) ? apiValues?.IndividualUniversityDetails?.plans?.planCards : []).map((item: any, index: number) => {

                                return (
                                    <div className="col-lg-4 col-md-6">
                                        <div className="card shadow-sm">
                                            <div className="card-body p-4">
                                                <div className="position-absolute top-0 end-0 mt-n3 me-n4">
                                                    <ImageWithBasePath
                                                        src="./assets/img/shapes/palanibgcard.png" alt="img" />
                                                </div>
                                                <div className="p-1 rounded-pill bg-[#FFEDF0] d-inline-flex">
                                                    <ImageWithBasePath
                                                        source={
                                                            item?.iconUrl
                                                        }
                                                        className="rounded-full"
                                                       style={{ height:40,
                                                        width:40}}
                                                        alt="Img"
                                                    />
                                                </div>
                                                <h5 className="mt-3 mb-1">
                                                    {item?.title}
                                                </h5>
                                                <p>
                                                    {item?.description}
                                                </p>
                                                <Link to={route.Unlock}>
                                                    <button className="flex items-center bg-red-500 hover:bg-red-600 text-white rounded-full px-5 py-2 transition duration-300">
                                                        <span>
                                                            {item?.buttonText}
                                                        </span>
                                                        <ImageWithBasePath
                                                            src="./assets/img/individual/Vector.png" alt="img" className="ml-2 text-xl text-white" />
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )

                            }) || []

                        }


                    </div>
                </div>
            </section>
        </>

    )
}

export default Benefits
